import { useEffect, useState } from "react";

function readMatches(query: string): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;

  return window.matchMedia(query).matches;
}

/**
 * Acompanha uma media query do CSS para as decisões que a folha de estilo não
 * resolve sozinha — na Tela Inicial, deixar de oferecer a Visão Geral na versão
 * responsiva (RN07), e não apenas escondê-la visualmente.
 *
 * Sem `matchMedia` disponível devolve `false`, ou seja, a versão Desktop.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => readMatches(query));

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;

    const list = window.matchMedia(query);
    setMatches(list.matches);

    function handleChange(event: MediaQueryListEvent) {
      setMatches(event.matches);
    }

    list.addEventListener("change", handleChange);

    return () => list.removeEventListener("change", handleChange);
  }, [query]);

  return matches;
}
